import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import TournamentSection from './components/TournamentSection';
import NewsSection from './components/NewsSection';
import StatsSection from './components/StatsSection';
import PartnersSection from './components/PartnersSection';
import { heroSlides, tournaments, newsArticles, platformStats, partners } from '@/mocks/home';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '开云电竞',
  url: 'https://www.kaiyunesports.com',
  description: '开云电竞是面向电竞爱好者的专业竞技平台，提供丰富的电竞赛事、实时数据与竞技数据服务。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.kaiyunesports.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="开云电竞 - 专业电竞平台官方入口 | 电竞赛事投注与竞技数据服务"
        description="开云电竞是面向电竞爱好者的专业竞技平台，提供丰富的电竞赛事、实时赔率与竞技数据服务。加入开云电竞，体验顶级电竞赛事投注与互动，安全稳定、注册便捷，立即开启你的电竞之旅。"
        keywords="开云电竞,开云电竞官网,开云电竞平台,开云电竞注册,开云电竞赛事,电竞竞技平台,电竞赛事投注"
        canonicalUrl="https://www.kaiyunesports.com"
        ogTitle="开云电竞 - 专业电竞平台官方入口"
        ogDescription="加入开云电竞，体验顶级电竞赛事投注与互动，安全稳定、注册便捷，立即开启你的电竞之旅。"
        ogImage="https://readdy.ai/api/search-image?query=esports%20platform%20brand%20banner%20with%20professional%20gaming%20arena%2C%20modern%20and%20clean%20design%2C%20golden%20and%20red%20accents%2C%20Chinese%20esports%20branding&width=1200&height=630&seq=og-home-01&orientation=landscape"
        schemaData={homeSchema}
      />

      <HeroSection slides={heroSlides} />

      <TournamentSection tournaments={tournaments} />

      <NewsSection articles={newsArticles} />

      <StatsSection stats={platformStats} />

      <PartnersSection partners={partners} />

      <section className="w-full py-14 md:py-20 bg-background-100">
        <div className="w-full px-6 md:px-10 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
            准备好开启你的电竞之旅了吗？
          </h2>
          <p className="text-foreground-600 text-sm mb-8 max-w-xl mx-auto">
            加入开云电竞，与百万电竞爱好者一起，体验最专业的电竞赛事服务
          </p>
          <a
            href="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            立即加入 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </section>
    </>
  );
}